import text from "../text";
export const pdfRender = async (arg) => {
    try {
        const { value } = arg;
        // @ts-ignore
        const selected = value.options.find((option) => option.selected)?.label || '';
        await text.pdf({ ...arg, value: selected });
    }
    catch (error) {
        console.log(error);
    }
};
//# sourceMappingURL=pdfRender.js.map